import { render, staticRenderFns } from "./AskFeedback.vue?vue&type=template&id=34d9a7ab&scoped=true&"
import script from "./AskFeedback.vue?vue&type=script&lang=js&"
export * from "./AskFeedback.vue?vue&type=script&lang=js&"
import style0 from "./AskFeedback.vue?vue&type=style&index=0&id=34d9a7ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d9a7ab",
  null
  
)

export default component.exports